import { createContext } from "react";
import { initialState } from "../../../reducers/reservation";
import ReservationProps from "./reservationProps";

const emptyFunc = (): void => {};
const defaultValue: ReservationProps = {
	profile: null,
	clubDetails: null,
	clubInfo: null,
	reservation: initialState,
	goBack: emptyFunc,
	setPage: emptyFunc,
	getReservationContext: null,
	addCard: null,
	getPaymentCards: null,
	validateAndBook: null,
	selectCard: null,
	selectPaymentNetwork: null,
	getReservationPartnerSuggestions: null,
	loadFriends: null,
	friends: [],
	addPartnerToReservation: null,
	removePartnerFromReservation: null,
	socialFind: null,
	clearReservationContext: null,
	editing: false,
	onCloseClicked: null,
	courts: [],
	onLoginButtonClicked: null,
	onBookingSuccess: null,
	widgetMode: false,
};

const ReservationPageContext = createContext(defaultValue);
export default ReservationPageContext;
